"use client";

import React from "react";
import { Facebook, Twitter, Instagram, Youtube, Phone, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const phone = "+49 30 12345678";
  const email = "info@architektur-news.de";
  const businessName = "Architektur-News";
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "#",
    label: "X"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Youtube,
    href: "#",
    label: "YouTube"
  }];
  return <footer data-section-id="67829" id="seitenabschluss" className="dark bg-[#24272D] text-white font-sans">
      <div className="max-w-[1200px] mx-auto px-6">
        {}
        <div className="flex flex-col md:flex-row justify-between items-center py-10 gap-8">
          {}
          

          {}
          <Button asChild variant="outline" className="rounded-none border-white text-white hover:bg-white hover:text-[#24272D] uppercase px-8 py-6 text-sm tracking-widest transition-colors duration-300">
            
          </Button>
        </div>

        <div className="text-sm text-[#666666] mt-4 mb-8 text-center md:text-left leading-relaxed">
          Postanschrift Hamburg, architektur-news, Randstraße 1, D-22525 Hamburg, Tel.{" "}
          <Link to="tel:+494040117991" className="hover:text-white transition-colors">
            +49 40 / 401 179 91
          </Link>
          , E-Mail{" "}
          <Link to="mailto:office@architektur-news.de" className="hover:text-white transition-colors">
            office@architektur-news.de
          </Link>
          , Herausgeber Boethe-Architektur
        </div>

        {}
        <Separator className="bg-[#3B404A] h-px w-full" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center py-6 gap-4 text-xs md:text-sm">
          {}
          <div className="text-[#666666] text-center md:text-left leading-relaxed">© 2012 - 2026 • Architektur-News is • All Rights Reserved • Developed by Iso</div>

          {}
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8 font-medium">
            
            
          </div>
        </div>
      </div>
    </footer>;
}